import React from 'react';

import { NavigationItemLink, NavigationSubItem } from '../../index';

export const NavigationItem = ({
    navItems,
    onItemClick = () => { },
    isSelectedLink = () => { },
    isActiveSubMenu = () => { },
    toggleMainMenu = () => { }
}) => {

    return <ul>
        {(navItems && navItems.length > 0) && navItems.map((navItem, index) => {
            const subMenuItem = navItem.subMenuItems;
            const navItemIndex = `${index}`;
            const altUrls = navItem?.altUrls ? navItem?.altUrls : null;
            const isNavItemSelected = isSelectedLink(navItem?.url, altUrls);
            const activeSubMenu = !isNavItemSelected && isActiveSubMenu(navItemIndex); //If nav item is selected ie has matching url then sub menu is not active 

            return <li
                className={`bsw-navigation__item ${activeSubMenu ? 'active' : ''}`}
                data-key={index}
                key={index}
            >
                <NavigationItemLink
                    index={index}
                    navItem={navItem}
                    selected={isNavItemSelected}
                    isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                    onItemClick={(...props) => { onItemClick(...props); }}
                    toggleMainMenu={toggleMainMenu}
                />
                {subMenuItem !== null && activeSubMenu &&
                    <NavigationSubItem
                        label={subMenuItem.menuLabel}
                        subNavItems={subMenuItem.menuItems}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        onDismiss={(...props) => { onItemClick(...props) }}
                        onSubItemClick={(e, subItemIndex, subItemLabel) => { onItemClick(e, navItemIndex, subItemLabel) }} // Passing nav item index instead of sub item index for correct active nav item state
                        toggleMainMenu={toggleMainMenu}
                    />
                }
            </li>
        })
        }
    </ul>
}
